<template>
  <v-app :class="[$route.path.indexOf('indexshs')>-1?'indexSHSBgColor':'back']">
    <v-main  fluid fill-height  :class="['back',SHORTCUT=='U'&&$vuetify.breakpoint.smAndDown?'shortCutTop':'',SHORTCUT=='D'&&$vuetify.breakpoint.smAndDown?'shortCutDown':'',]" app  >
      <!--:style="{padding:$route.path.indexOf('indexshs')>-1?'0px':'auto'}"-->
      <v-container  fluid  fill-height app :class="[$route.path.indexOf('indexshs')>-1?'indexPd':'']">
        <transition  name="slide-fade">
          <router-view ></router-view>
        </transition>
      </v-container>
    </v-main>

  </v-app>
</template>

<script>
    import "babel-polyfill"
export default {
  name: 'App',
  data: () => ({
   hospId:'',
   zone:'',
   SHORTCUT:'',
  }),
    created(){
      this.axios_getSetHospId("HOSP_ID");
      this.axios_getSetZone("ZONE");
      this.axios_getRegSetShortcut();
    },
    methods:{
        loadCssFile(hospId){
            /*JavaScript動態載入Css檔案*/
            var cssTag = document.getElementById('loadCss');
            var head = document.getElementsByTagName('HEAD').item(0);
            if(cssTag) head.removeChild(cssTag);
            var cssNode = document.createElement('link');
            cssNode.rel = 'stylesheet';
            cssNode.href = 'style/'+hospId+'.css?1110302';/*附帶時間引數，防止快取*/ //?t='+ new Date().getTime()
            cssNode.id = 'loadCss';
            head.appendChild(cssNode);
        },
        axios_getSetHospId (code){ //參數代碼查詢
            let url = '';
            this.hospId = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/"+code;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                      this.hospId = response.data.resultSet[0].value1;
                        if(this.$route.query.hospId!==undefined){
                            this.$store.commit('setHospitalId', this.$route.query.hospId);
                            this.loadCssFile(this.$route.query.hospId);
                        }else {
                            this.$store.commit('setHospitalId', this.hospId);
                            this.loadCssFile(this.hospId);
                        }
                    }else{
                        if(this.$route.query.hospId!==undefined){
                            this.$store.commit('setHospitalId', this.$route.query.hospId);
                            this.loadCssFile(this.$route.query.hospId);
                        }else {
                            this.hospId = '';
                        }

                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.hospId = '';
                    } catch(err) {
                        this.hospId = '';
                    }
                    this.hospId = '';
                });
        },

        axios_getSetZone (code){ //參數代碼查詢
            let url = '';
            this.zone = '';
            url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/"+code;

            this.$http.get(url).then(response =>{
                if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                    this.zone = response.data.resultSet[0].value1;
                    if(this.$route.query.zone!==undefined){
                        this.$store.commit('setZone', this.$route.query.zone);
                    }else {
                        this.$store.commit('setZone', this.zone);
                    }
                }else{
                    if(this.$route.query.zone!==undefined){
                        this.$store.commit('setZone', this.$route.query.zone);
                    }else {
                        this.zone = '';
                    }

                }


            }).catch(error =>  {
                try {
                    console.log(error.response.data.status);
                    this.zone = '';
                } catch(err) {
                    this.zone = '';
                }
                this.zone = '';
            });
        },
        axios_getRegSetShortcut (){ //參數代碼查詢 ZONE HOSP_ID
            let url = '';
            this.SHORTCUT = '';
            url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/SHORTCUT";

            this.$http.get(url).then(response =>{
                if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                    this.SHORTCUT = response.data.resultSet[0].value1;
                }else {
                    this.SHORTCUT = '';
                }

            }).catch(error =>  {
                this.SHORTCUT = '';
                try {
                    console.log(error.response.data.status);
                } catch(err) {
                    console.log(err.response.data.status);
                }
            });
        },

    }
};
</script>

<style>

  .indexSHSBgColor{ /**SHS首頁 補底色 1101110**/
    background-color: #0494AC!important;
  }

  ol {
    list-style: decimal!important;
  }

  ul {
    list-style: disc!important;
  }

  .indexPd{
    padding: 0px!important;
  }

  .shortCutTop{
    margin-top: 50px;
  }

  .shortCutDown{
    margin-bottom: 56px;
  }

  .theme--light.v-chip:not(.v-chip--active) {
    background: #fff!important;
  }

  .btnOutLine .badge {
    color: #242424;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(255,255,255,1)), color-stop(72%, rgba(255,255,255,1)), color-stop(95%, rgba(163,177,198,1)), to(rgba(163,177,198,1)));
    background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 72%, rgba(163,177,198,1) 95%, rgba(163,177,198,1) 100%);
    border-radius: 0px;
    border: 0.5px solid #727171;
    font-size: 16px;
    padding: 0px;
    -webkit-box-shadow: 0.5px 0.5px 0.5px 0.5px #cccccc;
    box-shadow: 0.5px 0.5px 0.5px 0.5px #cccccc;
    margin-left: 5px;
  }

  .fontMiddle{
    font-size: 1.2rem;
  }

  /**隱藏 數字上下按鈕 1090429 Ivy add**/
  /* Chrome, Safari, Edge, Opera */
  .hideNum .v-text-field__slot input::-webkit-outer-spin-button,
  .hideNum .v-text-field__slot input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /****隱藏 數字上下按鈕 1090429 Ivy add*****/
  /* Firefox */
  .hideNum .v-text-field__slot input[type=number] {
    -moz-appearance: textfield;
  }

  .theme--dark.v-input:not(.v-input--is-disabled) input, .theme--dark.v-input:not(.v-input--is-disabled) textarea {
    color: #fff;
    text-align: center!important;
  }
  /***固定table 表頭 可移動y軸***/
  .v-table__overflow {
    width: 100%;
    overflow-x: auto;
    overflow-y: auto!important;
  }



  .v-treeview-node__root {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-height: 34px!important;
    white-space: pre-line;
    overflow: auto;
  }

  .v-treeview-node__content {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-preferred-size: 0%;
    flex-basis: 0%;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    min-width: 0;
    font-size: 1.1rem;
  }

  .v-treeview-node__label {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: inherit;
    margin-left: 0px!important;
    overflow: hidden;
    text-overflow: ellipsis!important;
    white-space: pre-line!important;
  }

  .v-data-table th {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 1.1rem!important;
    height: auto;
    /*border-right: 1px solid #DDDDDD;*/
    /*border-bottom: 1px solid #DDDDDD;*/
    /*border: 1px solid  var(--v-accent-base)!important;*/
  }

  /*雙行換色*/
  tbody tr:nth-of-type(odd) {
    background-color: var(--v-even-base)!important;
  }



  .v-data-table td {
    padding: 0px 5px 0px 5px!important;
    font-size: 1.1rem !important;
    /*border-right: 1px solid #DDDDDD;*/
    /*border-bottom: 1px solid #DDDDDD;*/
    /*border: 1px solid #DDDDDD !important;*/
  }

  .cardBgColorStyle{
    padding:0px 10px;
  }

  li.disabled > div.v-breadcrumbs__item { /**加深 麵包屑 disabled文字顏色***/
    color:#3e2723!important;
    pointer-events: none;
    font-weight: bold;
  }

  li>div.v-breadcrumbs__item {
    color: black;
    cursor: pointer;
  }

  .v-breadcrumbs {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    list-style-type: none;
    margin: 0;
    padding: 0px 5px!important;
    padding-bottom: 10px!important;
  }

  .v-breadcrumbs__item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    text-decoration: none;
    -webkit-transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    font-size: 1.2rem;
  }

  .mine-custom-cell {
    padding-left: 5px;
  }
  .mine-custom-cell .v-table-body-cell {
    padding: 0;
    white-space: normal;
    line-height: normal !important;
    /* display: table-cell; */
    /* vertical-align: middle; */
    position: relative;
  }
  .mine-custom-cell .v-table-body-cell span {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .v-table-class{
    font-size: 1rem;
  }

  .v-table-title-class {
    font-size: 1.1rem;
    font-weight: bold;
  }

  .v-table-body-class {
    font-size: 1.1rem;
  }

  .theme--light.v-btn {
    font-size: 1rem!important;
  }

  .theme--dark.v-btn {
    font-size: 1rem!important;
  }

  .theme--dark.v-label {
    color: white!important;
  }

  .v-label {
    font-size: 1rem!important;
    line-height: 1;
    min-height: 8px;
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }

  /*tr:nth-child(even){*/
  /*background-color: var(--v-even-base);*/
  /*}*/

  /*.v-list--three-line .v-list__tile {*/
  /*height: auto;*/
  /*}*/
  .v-datatable thead th.column.sortable{  /**table 文字靠左對齊**/
    text-align: left;
    border: 1px solid black;
  }

  /*.v-carousel .v-carousel__controls { margin-bottom: 15px!important; }*/

  *{
    font-family: iKnowFont;
  }

  html {
    font-size: 16px!important;
    overflow-y: auto;
    /*overflow-y: hidden;*/
  }
  input {
    font-size: 1rem!important;
  }
  /* 元件使用, 半透明*/
  .backComponent{
    background-color:rgba(255, 255, 255, 0.3);
    background-size: cover;
    padding: 0px;
    /*margin: -10px;*/
    width: 100%;
    height: 102%;
  }
  .offset-toolbar {
    position: relative;
    top:-15px;
    left: -15px;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active{
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-active {
    transform: translateX(-430px);
    opacity: 0;
  }

  /**table CSS相關設定 須設在此處 方有作用 因為CSS載入順序，將CSS設在元件頁無用處**/
  table.v-table thead th {
    height: 40px;
    color: black!important;
    /*font-size: 16px;*/
    font-size: 1.1rem!important;
    font-weight: bold!important;
    background-color: var(--v-tablehead-base);
    /*background: linear-gradient(to bottom, #F0E3FD 0, #E1C5FF 100%);*/
  }

  table.v-table tbody td {
    /*font-size: 14px;*/
    font-size: 1rem!important;
    font-weight: 400;
    /*color: black !important;*/
  }

  .v-input input {
    max-height: 30px!important;

  }

  /*table.v-table thead.v-datatable__progress > th{*/
  /*height: 40px;*/
  /*}*/

  table.v-table thead tr {
    height: auto;
    font-weight: bold;
  }

  /*** 可改變 table 的 內邊距↓****/
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    /*padding: 0px 0px 0px 15px;*/  /***1080215 內邊距*/
    color: black;
    height: 45px;
    /*font-size:16px;*/
    font-size: 1.1rem!important;
  }
  /*** 可改變 table 的 內邊距↑****/
  /***檢驗報告 有icon的Button外觀設定 後面要用 !important 傳到Server端才會有效果**/
  .btnOutLine{
    border-radius: 6px!important; /**16**/
    padding: 0px 12px 0px 12px!important;
    margin-bottom: 2px!important;
    margin-top: 5px!important;
    margin-right: 0px!important;
    color: black!important;
    background:linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(201,202,201,1) 100%);
    /*background:linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(201,202,201,1) 100%)!important;*/
    border:1px solid #727171!important;
    /*font-size: inherit; !***加上此文字放大**!*/
    font-size: inherit!important;
    padding: 1px 5px 1px 5px!important;
    font-weight: bold!important;
  }

  .btnOutLine:hover{
    border-radius: 6px; /**16**/
    padding: 0px 12px 0px 12px;
    margin-bottom: 2px;
    margin-top: 5px;
    margin-right: 0px;
    color: black;
    background: linear-gradient(to bottom, #DBDCDB 50%, #FEFEFE 100%)!important;
    font-size: inherit;
    padding: 1px 5px 1px 5px;
    font-weight: bold;
    border:1px solid #727171!important;
    /*border:0.5px solid #727171;*/
    /*font-size: inherit; !***加上此文字放大**!*/
  }

  .tabsHeight{
    /*height: 50px!important;*/
    font-size: inherit;
    font-weight: bold;
    margin-bottom: -8px;
    margin-top: -8px;
  }
  .tabsDefault{
    height: 40px;
    font-size: inherit;
    margin-right: 5px;
    color: black !important;
    font-weight: bold;
    background:linear-gradient(to bottom, rgba(210,184,255,1) 0%, rgba(181,138,255,1) 100%);
    font-size:16px;
    border-radius:15px 15px 0px 0px;
    margin-left:2px;
    padding: 6px 6px -1px 0px;
  }

  .tabsHeightActive{
    color: white ;
    border-radius:15px 15px 0px 0px;
    height: 40px;
    font-size: inherit;
    background: linear-gradient(to bottom, rgba(173,129,227,1) 0%, rgba(142,62,240,1) 70%, rgba(173,129,227,1) 100%); /****original parcent 0 50 100 ***/
  }

  .panelOutLine{
    border: 1px solid #DEDEDE;
  }

  .labelFont {
    line-height: 62px;
  }

  
</style>
